import React from "react"
import {connect} from "@irati/store"
import {isNewScheduledRecognition} from "@irati/recognition/utils/polls/isNew"
import FormattedMessage from "@irati/utils/lang"
import mainTheme from "@irati/ui/src/global/theme"
import CompanyValues from "@irati-web/companyvalues/src/components/CompanyValuesList"
import {SchedulerEvent, SchedulerEventPublishRecognitionVisibility, SchedulerEventStatus} from "@irati/types"
import momentTZ from "moment-timezone"
import Flex from "@irati/ui/src/Flex"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {Body} from "@irati/ui/src/Typography"
import {FeedItem} from "../../Feed"
import WhoCreated from "../../WhoCreated"
import ProfilePicGroup, {OUTER_WRAPPER_SIZE, SINGLE_PICTURE_SIZE, MULTIPLE_PICTURE_SIZE} from "../../ProfilePicGroup"
import ModeratedMessage from "../../shared/Moderated"
import OccasionIcon from "../../shared/OccasionIcon"
import {ActivityScheduledRecognition as IconsActivity} from "../../Icons"
import Details from "../../Details/ScheduledRecognitionDetails"
import BodyWrapper from "../../shared/BodyWrapper"
import {IconsRow, FlexRow, BodyContainer} from "./styled"
import {Recognition as ScheduledRecognitionTitle} from "./Titles"
import {EndDate, StyledBody} from "./styled/Card"

interface ScheduledRecognitionProps {
  recognition: SchedulerEvent
  className: string
  onClick: (item: SchedulerEvent) => void
  isMobile: boolean
  id: string
}
const ScheduledRecognition: React.FC<ScheduledRecognitionProps> = (props) => {
  const {recognition, className, onClick, isMobile, id: feedItemId = "scheduled-recognition"} = props

  const users = recognition.payload?.publishRecognition?.receivers
  const isNew = isNewScheduledRecognition(recognition)

  const timezone = recognition.originalTimezone
  const failed = recognition.status === SchedulerEventStatus.Failed
  const scheduledDate = momentTZ.tz(recognition.when, timezone).format("Do, MMMM YYYY, h:mm A")
  const dateMessage = recognition.payload?.publishRecognition?.rewardAmount
    ? "platform.recognition.scheduledReward.date.lbl"
    : "platform.recognition.scheduled.date.lbl"
  const showScheduledRecognition = () => onClick(recognition)
  return (
    <FeedItem className={className} isNew={isNew}>
      <FlexRow isPrivate={recognition.payload?.publishRecognition?.visibility === SchedulerEventPublishRecognitionVisibility.Private}>
        <ProfilePicGroup
          users={users}
          outerWrapperSize={OUTER_WRAPPER_SIZE(isMobile)}
          singlePictureSize={SINGLE_PICTURE_SIZE(isMobile)}
          multiplePictureSize={MULTIPLE_PICTURE_SIZE(isMobile)}
        />
        <BodyWrapper>
          <BodyContainer>
            <ScheduledRecognitionTitle recognition={recognition} isScheduled />
            <IconsRow>
              <OccasionIcon occasion={recognition.payload?.publishRecognition?.occasion} />
              <CompanyValues companyValues={{results: recognition.payload?.publishRecognition?.companyValues}} limit={1} />
            </IconsRow>
            <Details recognition={recognition} />
            {!failed && (
              <EndDate>
                <FormattedMessage id={dateMessage} values={{date: scheduledDate, timezone}} />
              </EndDate>
            )}
            {failed && (
              <Flex color={mainTheme.colors.error} alignItems="center" gap={1}>
                <Icon icon={IconTypes.circleAlertFill} />
                <Body small color={mainTheme.colors.error}>
                  <FormattedMessage id="platform.recognition.scheduled.publishFailed" values={{date: scheduledDate}} />
                </Body>
              </Flex>
            )}
            <StyledBody small marginBottom={1}>
              <ModeratedMessage message={recognition.payload?.publishRecognition?.message} />
            </StyledBody>
            <WhoCreated createdBy={recognition.createdBy} />
            <IconsActivity feedItemId={feedItemId} item={recognition} viewRecognition={showScheduledRecognition} />
          </BodyContainer>
        </BodyWrapper>
      </FlexRow>
    </FeedItem>
  )
}

const mapStateToProps = ({mq}) => {
  return {
    isMobile: mq.lessThan.md
  }
}

export default connect(mapStateToProps)(ScheduledRecognition)
